import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "genericPadding hasHeader hasFooter bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "form-group squareInputContainer withLabel"
}
const _hoisted_6 = { class: "form-group squareInputContainer withLabel" }
const _hoisted_7 = { class: "form-group squareInputContainer withLabel" }
const _hoisted_8 = { class: "fs_12 grey mt-3 d-block mt-3" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" ** ")
const _hoisted_10 = { class: "footerButtonContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode(_component_localized_text, {
        class: "fs_12 greyBlue",
        localizedKey: "app_cambialapassword",
        text: "Cambia la password"
      }),
      _hoisted_4
    ]),
    (_ctx.hasOldPassword)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_vecchiapassword",
              text: "Vecchia password",
              class: "fs_12 grey"
            })
          ]),
          _withDirectives(_createVNode("input", {
            type: "password",
            class: "genericInput squareInput",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePassword.oldPassword = $event))
          }, null, 512), [
            [_vModelText, _ctx.changePassword.oldPassword]
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      _createVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_nuovapassword",
          text: "Nuova password",
          class: "fs_12 grey"
        })
      ]),
      _withDirectives(_createVNode("input", {
        type: "password",
        class: "genericInput squareInput",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePassword.newPassword = $event))
      }, null, 512), [
        [_vModelText, _ctx.changePassword.newPassword]
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_ripetipassword",
          text: "Ripeti password",
          class: "fs_12 grey"
        })
      ]),
      _withDirectives(_createVNode("input", {
        type: "password",
        class: "genericInput squareInput",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.repeatPassword = $event))
      }, null, 512), [
        [_vModelText, _ctx.repeatPassword]
      ])
    ]),
    _createVNode("span", _hoisted_8, [
      _hoisted_9,
      _createVNode(_component_localized_text, {
        localizedKey: "app_passwordrestrizione",
        text: "La password deve avere una lunghezza di almeno 6 caratteri, contenere una lettera maiuscola, una minuscola, e un numero",
        class: "fs_12 grey"
      })
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("button", {
        class: "genericButton bgGreyBlue w-100",
        disabled: _ctx.disableButton,
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirm()))
      }, [
        _createVNode(_component_localized_text, {
          class: "fs_14 white",
          localizedKey: "app_conferma",
          text: "Conferma"
        })
      ], 8, ["disabled"])
    ])
  ]))
}